module.exports = __webpack_public_path__ + "static/media/app-play-store.2f826fdc.png";